import { Modal } from "antd";
import { ModalProps } from "antd/lib/modal";
import classnames from "classnames";
import React from "react";
import "./index.scss";

const cls = "AdaptionModal";

export const AdaptionModal: React.SFC<ModalProps> = props => {
  const { className, ...rest } = props;
  return (
    <Modal
      className={classnames(className, cls)}
      {...rest}
      width="100%"
    ></Modal>
  );
};
